import React, {Component} from 'react';
import {connect} from 'react-redux';
import commonActionCreators from "../../../shared/store/common/action-creators";
import './SignActorsManage.scss'
import usersActionCreators from "../../store/users/action-creators";
import {hasSignActors} from "../../services/sign-flow";
import ReactTooltip from 'react-tooltip';

class SignActorsManage extends Component {
  constructor(props) {
    super(props);

    this.props.fetchFormTypes();
    this.props.fetchUsers();
  }

  get formList() {
    let formTypes = Object.keys(this.props.oit.trainingTracker.trainingProgram.signFlow);
    return formTypes.filter(formType => hasSignActors(this.props.oit.trainingTracker.trainingProgram.signFlow, formType))
  }

  fromTypeSignActors(formType, actor) {
    let signActors = this.props.oit.trainingTracker.signActors && this.props.oit.trainingTracker.signActors.find(sa => sa.type === formType);

    if (this.props.phase) {
      signActors = this.props.phase.signActors && this.props.phase.signActors.find(sa => sa.type === formType);
    }

    return signActors
      ? signActors[actor] || ''
      : ''
  }

  onAddSignActor(formType, actor, guid) {
    let signActor = this.props.oit.trainingTracker.signActors && this.props.oit.trainingTracker.signActors.find(sa => sa.type === formType);
    let signActors = [];

    let signActorsTemp = this.props.oit.trainingTracker.signActors;
    if (this.props.phase) {
      signActorsTemp = this.props.phase.signActors;
      signActor = this.props.phase.signActors && this.props.phase.signActors.find(sa => sa.type === formType);
    }

    if(!signActor) {
      signActors = [...(signActorsTemp || []), {
        type: formType,
        approverOne: null,
        approverTwo: null,
        [actor]: guid
      }]
    } else {
      signActors = signActorsTemp.map(sa =>
        sa.type === formType
        ? {
            ...sa,
            [actor]: guid
          }
        : sa)
    }

    this.props.onSignActorsUpdate && this.props.onSignActorsUpdate(signActors)
  }

  filterOfficersForSignFlow(formType, signFlowStep) {
    const signFlow = this.props.oit.trainingTracker.trainingProgram.signFlow[formType];
    const signFlowRoles = signFlow[signFlowStep];

    let users = [];
    if (signFlowRoles && signFlowRoles.roles) {
      users = this.props.users && this.props.users.filter(u => signFlowRoles.roles.some(v => u.roles.map(user => user.scope).includes(v)))
    }


    return users;
  }

  getProgramFullName(programType) {
    const form = this.props.forms.find(form => form.type === programType);

    if (form) {
      return form.name;
    }
  }

  render() {

    return (
      <div className="sign-actors-manage">
        {this.formList.map(formType => (
          <div className="form-sign-actor" key={formType}>
            <ReactTooltip
              place="top"
              className="customTheme"
              effect="solid"
            />
            <div className="form-type" data-tip={this.getProgramFullName(formType)}>
              {formType}
            </div>
            <div className="form-sign-choose-user">
              <div className="form-sign-label"><b>Approver one</b></div>

              { this.filterOfficersForSignFlow(formType, 'approve_one') &&
                <select
                  disabled={this.filterOfficersForSignFlow(formType, 'approve_one').length === 0}
                  className="form-control"
                  value={this.fromTypeSignActors(formType, 'approverOne')}
                  onChange={(e) => this.onAddSignActor(formType, 'approverOne', e.target.value)}>
                  <option value={''}>Set approver one</option>
                  { this.filterOfficersForSignFlow(formType, 'approve_one').map(u => (
                    <option key={u.guid} value={u.guid}>{u.getFullName()}</option>
                  ))}
                </select>
              }
            </div>
            <div className="form-sign-choose-user">
              <div className="form-sign-label"><b>Approver two</b></div>

              { this.filterOfficersForSignFlow(formType, 'approve_two') &&
              <select
                disabled={this.filterOfficersForSignFlow(formType, 'approve_two').length === 0}
                className="form-control"
                value={this.fromTypeSignActors(formType, 'approverTwo')}
                onChange={(e) => this.onAddSignActor(formType, 'approverTwo', e.target.value)}>
                <option value={''}>Set approver two</option>
                { this.filterOfficersForSignFlow(formType, 'approve_two').map(u => (
                  <option key={u.guid} value={u.guid}>{u.getFullName()}</option>
                ))}
              </select>
              }
            </div>
            <div className="form-sign-choose-user">
              <div className="form-sign-label"><b>Approver three</b></div>

              {this.filterOfficersForSignFlow(formType, 'approve_three') &&
              <select
                disabled={this.filterOfficersForSignFlow(formType, 'approve_three').length === 0}
                className="form-control"
                value={this.fromTypeSignActors(formType, 'approverThree')}
                onChange={(e) => this.onAddSignActor(formType, 'approverThree', e.target.value)}>
                <option value={''}>Set approver three</option>
                {this.filterOfficersForSignFlow(formType, 'approve_three').map(u => (
                  <option key={u.guid} value={u.guid}>{u.getFullName()}</option>
                ))}
              </select>
              }
            </div>
            <div className="form-sign-choose-user">
              <div className="form-sign-label"><b>Approver four</b></div>

              {this.filterOfficersForSignFlow(formType, 'approve_four') &&
              <select
                disabled={this.filterOfficersForSignFlow(formType, 'approve_four').length === 0}
                className="form-control"
                value={this.fromTypeSignActors(formType, 'approverFour')}
                onChange={(e) => this.onAddSignActor(formType, 'approverFour', e.target.value)}>
                <option value={''}>Set approver four</option>
                {this.filterOfficersForSignFlow(formType, 'approve_four').map(u => (
                  <option key={u.guid} value={u.guid}>{u.getFullName()}</option>
                ))}
              </select>
              }
            </div>
            <div className="form-sign-choose-user">
              <div className="form-sign-label"><b>Approver five</b></div>

              {this.filterOfficersForSignFlow(formType, 'approve_five') &&
              <select
                disabled={this.filterOfficersForSignFlow(formType, 'approve_five').length === 0}
                className="form-control"
                value={this.fromTypeSignActors(formType, 'approverFive')}
                onChange={(e) => this.onAddSignActor(formType, 'approverFive', e.target.value)}>
                <option value={''}>Set approver five</option>
                {this.filterOfficersForSignFlow(formType, 'approve_five').map(u => (
                  <option key={u.guid} value={u.guid}>{u.getFullName()}</option>
                ))}
              </select>
              }
            </div>
          </div>
        ))}

      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  formTypes: state.common.formTypes,
  users: state.users.usersByMaster,
  forms: state.forms.list,
});

const mapDispatchToProps = (dispatch) => ({
  fetchFormTypes: () => dispatch(commonActionCreators.fetchFormTypes()),
  fetchUsers: () => dispatch(usersActionCreators.fetchUsersByMaster())
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SignActorsManage);
